<div class="sub-header">
  <span class="col-md-12">
    &nbsp;
  </span>
</div>

<h1 translate>Login.In.Progress</h1>
